import type { MessageKey } from '../i18n/messages';
import type { AssistantFaqTopic } from './parseAssistantIntent';

export const ASSISTANT_FAQ_MESSAGE_KEYS: Record<AssistantFaqTopic, MessageKey> = {
  businessLounge: 'assistant.faq.businessLounge',
  becomeOwner: 'assistant.faq.becomeOwner',
  howBookingWorks: 'assistant.faq.howBookingWorks',
  voiceHelp: 'assistant.faq.voiceHelp',
};
